import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "absolute left-[10px] right-[10px] bottom-[10px] text-center z-[1] p-[10px]" }
const _hoisted_2 = {
  class: "active-auctions-timer block text-xs font-semibold text-gray-900 dark:text-gray-400",
  "data-duration": "9900",
  id: "active-auctions-timer"
}
const _hoisted_3 = { class: "day-span mx-[2px]" }
const _hoisted_4 = { class: "day" }
const _hoisted_5 = { class: "hours-span mx-[2px]" }
const _hoisted_6 = { class: "hours" }
const _hoisted_7 = { class: "minutes-span mx-[2px]" }
const _hoisted_8 = { class: "minutes" }
const _hoisted_9 = { class: "seconds-span mx-[2px]" }
const _hoisted_10 = { class: "seconds" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.days), 1),
        _cache[0] || (_cache[0] = _createTextVNode("d: "))
      ]),
      _createElementVNode("span", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.hours), 1),
        _cache[1] || (_cache[1] = _createTextVNode("h: "))
      ]),
      _createElementVNode("span", _hoisted_7, [
        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.hours), 1),
        _cache[2] || (_cache[2] = _createTextVNode("m: "))
      ]),
      _createElementVNode("span", _hoisted_9, [
        _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.minutes), 1),
        _cache[3] || (_cache[3] = _createTextVNode("s: "))
      ])
    ]),
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "absolute left-0 right-0 top-0 bottom-0 -z-[1] bg-white opacity-[.80] backdrop-blur-[12px]" }, null, -1))
  ]))
}